import { Stack, type Theme, useMediaQuery } from '@mui/material';
import PageContainer from '/@/components/bayer/page-container';
import Tabs from '/@/components/bayer/tabs';
import { _ } from '/@/locale';
import { objectEntries } from '/@/utils';
import Header from '../../../components/bayer/header';
import { type RVsTabType, useTabs } from '..';
import { RVCurrentCampaignDashboard } from './tabs/current-campaign';
import { RVPastReportsDashboard } from './tabs/past-campaign';
import { RecommendationsDashboard } from './tabs/recommendations';

const RVsListDashboard = () => {
    const { tab, handleTabChange } = useTabs();
    const isSmOrLower = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    const tabs: Record<RVsTabType, { label: string; disabled: boolean; component?: React.ReactNode }> = {
        'current-campaign': {
            label: _('Campaña actual'),
            disabled: false,
            component: <RVCurrentCampaignDashboard />,
        },
        'past-reports': {
            label: _('Reportes de campaña'),
            disabled: false,
            component: <RVPastReportsDashboard />,
        },
        recommendations: {
            label: _('Recomendaciones'),
            disabled: false,
            component: <RecommendationsDashboard />,
        },
    } as const;

    return (
        <PageContainer
            header={
                <Header
                    title={_('Representantes de ventas')}
                    subtitle={_('Accedé a una visión integral de tus RVs para brindar el asesoramiento que necesitan.')}
                    buttons={[]}
                />
            }
        >
            <Stack direction='column' spacing={3} mt={4}>
                <Tabs
                    options={objectEntries(tabs).map(([value, tab]) => ({
                        label: tab.label,
                        value,
                        disabled: tab.disabled,
                    }))}
                    value={tab}
                    setValue={(value) => handleTabChange(value)}
                    tabsVariant={isSmOrLower ? 'scrollable' : 'fullWidth'}
                />
                {tabs[tab as RVsTabType].component}
            </Stack>
        </PageContainer>
    );
};

export default RVsListDashboard;
